import { render, staticRenderFns } from "./FormRecebedores.vue?vue&type=template&id=d60f297a"
import script from "./FormRecebedores.vue?vue&type=script&lang=js"
export * from "./FormRecebedores.vue?vue&type=script&lang=js"
import style0 from "./FormRecebedores.vue?vue&type=style&index=0&id=d60f297a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports